import type { PublicHistoricalFigure } from "./types.ts";

// 浏览器只需要公开画像，付费报告正文仅保留在服务端构建中。
export const publicFigures: PublicHistoricalFigure[] = [
  {
    slug: "zhuge-liang",
    name: "诸葛亮",
    era: "三国",
    role: "谋略者",
    monogram: "亮",
    color: "#426a5a",
    labels: ["深谋远虑", "责任感", "秩序建构"],
    tagline: "你相信真正的从容，来自提前看见风向。",
    summary: "你习惯先看全局，再把复杂问题拆成可以推进的步骤。比起抢先表达，你更在意承诺能否兑现、系统能否长久运转。",
  },
  {
    slug: "li-bai",
    name: "李白",
    era: "盛唐",
    role: "自由表达者",
    monogram: "白",
    color: "#507aa6",
    labels: ["自由想象", "强烈表达", "不受拘束"],
    tagline: "你更愿意忠于生命的亮度，而不是安全的刻度。",
    summary: "你对新鲜、真诚与精神自由有天然敏感。你需要空间表达自己，也愿意为一次真正打动你的体验离开熟悉轨道。",
  },
  {
    slug: "wang-yangming",
    name: "王阳明",
    era: "明代",
    role: "知行实践者",
    monogram: "明",
    color: "#9a5f48",
    labels: ["内在坚定", "知行合一", "独立判断"],
    tagline: "你不等世界给出答案，行动本身就是求证。",
    summary: "你重视内在判断，也不满足于只在头脑里正确。越到复杂时刻，你越希望通过实际行动确认方向。",
  },
  {
    slug: "su-shi",
    name: "苏轼",
    era: "北宋",
    role: "豁达创造者",
    monogram: "轼",
    color: "#b8754f",
    labels: ["豁达适应", "创造表达", "生活感受"],
    tagline: "你能把命运给的转弯，过成另一种风景。",
    summary: "你既有原则，也有很强的生活恢复力。遭遇变化时，你往往不是假装无事，而是重新找到值得热爱的具体事物。",
  },
  {
    slug: "wu-zetian",
    name: "武则天",
    era: "唐代",
    role: "权势开拓者",
    monogram: "曌",
    color: "#854c65",
    labels: ["强势决断", "识人用人", "突破边界"],
    tagline: "你不等待位置被让出来，而会证明自己配得上它。",
    summary: "你对权力结构和现实机会十分敏锐。面对阻力时，你更可能提高掌控力，而不是降低目标。",
  },
  {
    slug: "zhang-juzheng",
    name: "张居正",
    era: "明代",
    role: "务实改革者",
    monogram: "居",
    color: "#6d604a",
    labels: ["务实改革", "效率纪律", "结果负责"],
    tagline: "你关心的不是方案听起来多好，而是它能否真的运转。",
    summary: "你倾向把宏大问题落到制度、节奏和责任上。比起温和地维持现状，你愿意为了有效结果推动艰难改变。",
  },
  {
    slug: "liu-bang",
    name: "刘邦",
    era: "汉初",
    role: "人心整合者",
    monogram: "邦",
    color: "#8a6f3b",
    labels: ["灵活应变", "知人善任", "机会嗅觉"],
    tagline: "你未必事事最强，却知道怎样让强者愿意同行。",
    summary: "你对人和局势的变化很敏锐，能承认自己不会什么，也能迅速抓住转机。你更相信有效组合，而不是独自证明。",
  },
  {
    slug: "tao-yuanming",
    name: "陶渊明",
    era: "东晋",
    role: "内在自洽者",
    monogram: "陶",
    color: "#748458",
    labels: ["内在自由", "淡泊清醒", "自我节奏"],
    tagline: "你不急着赢过世界，更在意没有输掉自己。",
    summary: "你对外部评价和权力竞争保持距离，更愿意维护生活的真实感。你需要独处，也擅长从简单事物里恢复能量。",
  },
  {
    slug: "li-qingzhao",
    name: "李清照",
    era: "两宋之际",
    role: "敏锐记录者",
    monogram: "清",
    color: "#7e688c",
    labels: ["细腻敏锐", "真实表达", "韧性记忆"],
    tagline: "你能察觉细微变化，也不愿把真实感受写得含糊。",
    summary: "你对语言、关系与环境的细节非常敏感。柔软并不等于脆弱，经历变化后，你更会把复杂感受沉淀成清醒表达。",
  },
  {
    slug: "cao-cao",
    name: "曹操",
    era: "东汉末",
    role: "乱局行动者",
    monogram: "操",
    color: "#5d5a67",
    labels: ["现实洞察", "快速决断", "不惧争议"],
    tagline: "你宁可在不完整的信息里行动，也不愿把机会让给犹豫。",
    summary: "你对局势、人才和风险有强烈嗅觉。相比维护一个纯粹形象，你更愿意承担争议，把现实问题推向结果。",
  },
  {
    slug: "zheng-he",
    name: "郑和",
    era: "明代",
    role: "远航组织者",
    monogram: "和",
    color: "#347b82",
    labels: ["探索勇气", "组织纪律", "跨界沟通"],
    tagline: "你敢去远方，也知道真正的远航离不开秩序。",
    summary: "你身上同时存在探索欲和组织感。你不是只凭冲动冒险，而是愿意为未知准备、协调并承担长期责任。",
  },
  {
    slug: "ban-zhao",
    name: "班昭",
    era: "东汉",
    role: "学识传承者",
    monogram: "昭",
    color: "#8f705c",
    labels: ["沉静学识", "秩序意识", "长期传承"],
    tagline: "你相信安静而准确的工作，也能穿过很长的时间。",
    summary: "你不一定追逐最显眼的位置，却重视知识、责任和完成度。你愿意接续未完成的工作，让经验真正被后来者使用。",
  },
];
